/**
 * @file BinRackSelectBar.tsx
 * @description Полоса «этикетки» над списком ячеек (phase19.22 шаг 5):
 *   плитки «Стеллаж A · 12» — отметить стеллаж целиком одним нажатием, и
 *   ссылка «История печати (N)».
 *
 * Плитка — переключатель (`aria-pressed`): повторное нажатие снимает весь
 * стеллаж. phase19.31: вид — пилюля кабинета (SC45, `FilterToggleChips`),
 * высота из темы (48 на телефоне, 56 у кладовщика до 1024). Пилюль много —
 * переносятся.
 */

import { History } from "lucide-react";

import type { BinSelection } from "./useBinSelection";
import { Button } from "../../ui/button";
import { FilterToggleChips } from "../../ui/FilterChips";

interface Props {
  selection: BinSelection;
  /** Задач в журнале печати ячеек; 0 — ссылки нет. */
  historyCount: number;
  onOpenHistory: () => void;
}

export function BinRackSelectBar({ selection, historyCount, onOpenHistory }: Props) {
  if (selection.racks.length === 0 && historyCount === 0) return null;

  return (
    <div className="flex flex-col gap-2 lg:flex-row lg:items-start lg:justify-between">
      {selection.racks.length > 0 ? (
        <div className="flex flex-col gap-1.5">
          <span className="text-xs text-on-surface-variant">
            Печать этикеток: выберите стеллаж целиком или отметьте ячейки
          </span>
          {/* Пилюли-переключатели кабинета (SC45): выбранная — на мягкой
              подложке, высота из темы; раньше — серые плитки 56px «как
              кнопки» (дефект приёмки 2026-10-02). */}
          <FilterToggleChips
            aria-label="Выбрать стеллаж целиком"
            items={selection.racks.map(({ rack, binIds }) => ({
              key: rack,
              label: `Стеллаж ${rack}`,
              count: binIds.length,
              pressed: selection.isRackSelected(rack),
              onToggle: () => selection.toggleRack(rack),
            }))}
          />
        </div>
      ) : null}
      {historyCount > 0 ? (
        <Button variant="ghost" className="self-start" onClick={onOpenHistory}>
          <History className="size-4" />
          <span className="ml-1.5">История печати ({historyCount})</span>
        </Button>
      ) : null}
    </div>
  );
}
